// extracted by mini-css-extract-plugin
export default {"title":"SerialBundleTitle_title","withoutText":"SerialBundleTitle_withoutText"};